// extracted by mini-css-extract-plugin
export default {"recommendationSelectionSelect":"DataScienceJobsTab_recommendationSelectionSelect__ZJZWw"};